import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cseDropdownMenuGroup = {
  paddingBlock: css`var(--cse-dropdown-menu-group-padding-y, ${csSpacing.spacing04})`,
  paddingInline: css`var(--cse-dropdown-menu-group-padding-x, ${csSpacing.spacing05})`,
  rowGap: css`var(--cse-dropdown-menu-group-row-gap, ${csSpacing.spacing05})`,
}

export const style: CSSResult = css`
  :host {
    --cse-expandable-list-row-gap: ${cseDropdownMenuGroup.rowGap};
    --cse-expandable-toggle-padding-x: ${cseDropdownMenuGroup.paddingInline};
  }

  .cse-dropdown-menu-group {
    display: flex;
    flex-direction: column;
    row-gap: ${cseDropdownMenuGroup.rowGap};
  }

  .options {
    display: block;
  }

  .title {
    display: block;
    padding-inline: ${cseDropdownMenuGroup.paddingInline};
    margin-top: ${cseDropdownMenuGroup.paddingBlock};
  }

  cse-divider {
    margin-top: ${cseDropdownMenuGroup.paddingBlock};
  }

  ::slotted(cse-link) {
    display: block;
    margin-top: ${cseDropdownMenuGroup.rowGap};
    padding-inline: ${cseDropdownMenuGroup.paddingInline};
  }
`
